import DesktopPopupBlockedIcon from '../../assets/popup-permission/mobile-popup-blocked.png';
import MobilePopupBlockedIcon from '../../assets/popup-permission/desktop-popup-blocked.png';

const OverlayComponentPopUp = () => {
  const PopupBlockedIcon =
    window.innerWidth > 768 ? DesktopPopupBlockedIcon : MobilePopupBlockedIcon;
  return (
    <>
      <div className="fixed top-0 left-0 right-0 bottom-0 text-white w-full h-screen overflow-hidden bg-gray-700 opacity-75"></div>
      <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen flex justify-center items-center text-white">
        <div className="bg-black opacity-[0.85] rounded-lg w-4/5 md:w-[50%] h-auto m-2 list-inside">
          <div className="space-y-4 w-full flex flex-col justify-start items-start ml-3">
            <h2 className="w-full text-lg p-2">
              Your popup permission is blocked. To continue:
            </h2>
            <div className="text-sm md:text-lg space-y-3 flex flex-col justify-start items-start list-inside pr-4">
              <ul className="pl-5 space-y-3 list-disc marker:text-blue-600">
                <li>
                  Look for a popup blocked icon at the extreme ends of the
                  address bar
                </li>
              </ul>
              <ul className="pl-5 space-y-3 list-disc marker:text-blue-600">
                <div className="flex justify-between gap-3 items-center">
                  <li>Click on the icon</li>
                  <img src={PopupBlockedIcon} className="h-[20px] w-[20px]" />
                </div>
              </ul>
              <ul className="pl-5 space-y-3 list-disc marker:text-blue-600">
                <li>Allow access and Refresh the page</li>
              </ul>
            </div>
            <div className="m-2 rounded-tl-3xl rounded-bl-3xl rounded-tr-[40px] rounded-br-[40px] bg-[#626262] w-[80%] flex justify-between items-center">
              <div className="text-center">
                <h2 className="text-white m-2">Fibe.in</h2>
              </div>
              <div className="right-0 top-0 bottom-0">
                <img className="" src={PopupBlockedIcon} />
              </div>
            </div>
            <div className="pb-3 mr-6">
              <span className="text-sm">
                Not able to find the icon? Allow location access from browser
                settings
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverlayComponentPopUp;
